'use strict';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  createUpdateApplicant, getYtjInformation, createSaveApplication,
  getFetchApplication, getValidateEmail, getValidatePhone,
  getValidatePhoneWithCode, getValidateEmailWithCode, getAsiakastietoScoringData
} from '../../actions/application';
import { GetAuthenticationSession, createLoginToken } from '../../actions/login';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button'
import MaskedInput from 'react-text-mask';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/styles';

import { FormControl } from '@material-ui/core';

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import IconAdd from '@material-ui/icons/Add';
import IconRemove from '@material-ui/icons/Remove';

import IconOk from '@material-ui/icons/Done';
import IconError from '@material-ui/icons/Error';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { GetFetchOffer } from '../../actions/loanOffer';
import Snack from '../utils/snack'
import CircularProgress from '@material-ui/core/CircularProgress';
import { GeneralFooter } from '../utils/generalFooter';
// import ApplicationDetails from './applicationDetails';
// import LoanPaymentDetails from './loanPaymentDetails';
import OptionalAttachments from '../becomeApplicant/optionalAttachments';
import queryString from 'query-string'
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import Slider from '@material-ui/core/Slider';
import Collapse from '@material-ui/core/Collapse';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { trackLoanApplication, trackButtonClick } from '../../utils/gtm';

import checkmarkImage from '../../img/checkmark.svg';
import { COLOR_CENTER_BORDER } from '../../theme/tokens';
import hero from '../../Hero.webp';
import { getCookie, getGclidFromQuery } from '../becomeApplicant/becomeApplicantProcess';
import { trackEvent } from '../../utils/gtm';

const maxAmt = 50000;
const minAmt = 2000;
const amtStep = 1000;
const maxLen = 24;
const minLen = 1;
const lenStep = 1;
const maxFree = 3;
const minFree = 0;

const styles = theme => ({
  checkmarkList: {
    textAlign: 'left',
    padding: 0,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    '& > li': {
      display: 'inline-block',
      '& > *': {
        display: 'inline-block',
        lineHeight: `${theme.spacing(3)}px`,
        verticalAlign: 'middle',
      },
      '&:not(:last-of-type)': {
        marginRight: '26px',
      },
      '&::before': {
        content: `url(${checkmarkImage})`,
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 10,
        height: `${theme.spacing(3)}px`,
      },
    },
  },
  calculatorMonthlyPaymentDetailBox: {
    borderWidth: '1px 0 1px 1px',
    borderStyle: 'solid',
    borderColor: '#EBEBEA',
    textAlign: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      borderWidth: '1px 1px 0 1px',
      padding: theme.spacing(1),
      '&:last-of-type': {
        borderBottomWidth: '1px',
      },
    },
    '&:last-of-type': {
      borderRightWidth: '1px',
    },
  },
  calculatorSliderText: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '28px',
    letterSpacing: '0.01em',
  },
  calculatorNumber: {
    fontWeight: 500,
    fontSize: 22,
    lineHeight: '28px',
    letterSpacing: '-0.2px',
  },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function getSimpleSteps() {
  return ['Rahoituksen perustiedot', 'Tunnistautuminen'];
}

const mapStateToProps = (state) => {
  return {
    application: state.application,
    offer: state.offer,
    authentication: state.auth
  };
};

const purposeStyle = {
  width: '200px',
  marginTop: '10px',
  fontSize: '10px'
}

const textStyle = {
  color: "black"
};
const iconStyle = {
  height: '15px'
}
const errorStyle = {
  color: 'red',
  marginTop: '20px'
}

const okStyle = {
  color: 'lightgreen',
  marginTop: '20px'
}


const mapDispatchToProps = (dispatch) => {
  return {

    updateApplication: (application) => dispatch(createUpdateApplicant(application)),
    getOffer: (loanAmt, loanLen, dueDate, capitalFreeMonths) => dispatch(GetFetchOffer(loanAmt, loanLen, dueDate, capitalFreeMonths)),
    getYtjInformation: (bic) => dispatch(getYtjInformation(bic)),
    getAuth: (id) => dispatch(GetAuthenticationSession(id)),
    saveApplication: (application) => dispatch(createSaveApplication(application)),
    fetchApplication: (application) => dispatch(getFetchApplication(application)),
    valEmail: (application) => dispatch(getValidateEmail(application)),
    valPhone: (application) => dispatch(getValidatePhone(application)),
    tryValEmailCode: (application) => dispatch(getValidateEmailWithCode(application)),
    tryValPhoneCode: (application) => dispatch(getValidatePhoneWithCode(application)),
    getScoringData: (application) => dispatch(getAsiakastietoScoringData(application)),
    createLoginToken: (serviceId, authenticationContext, applicationId) => dispatch(createLoginToken(serviceId, authenticationContext, applicationId)),

  };
};

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/]}
      keepCharPositions={false}
      showMask={false}
      InputLabelProps={{
        shrink: true,
      }}
      placeholderChar={'\u2000'}
    />
  );
}

function getSteps() {
  return ['Haettava rahoitus', 'Yrityksen tiedot', 'Yhteyshenkilön tiedot', 'Tunnistautuminen'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return '';
    case 1:
      return '';
    case 2:
      return '';
    default:
      return '';
  }
}

class LimitLoanProcess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      application: {
        loanAmount: 20000,
        loanLength: 12,
        capitalFreeMonths: 0,
        LoanPurposeTypeEnum: 0,
        LoanGuaranteeTypeEnum: 0,
        LoanDueDateTypeEnum: 0,
        loanApplicationLoanTypeEnum: 2,
        freeMonthsToPaymentsCheck: false,
        ApplicationSource: "",
        bic: "",
        affiliateCode: "",
        affiliate: ""
      },
      activeStep: 0,
      validation: {
        amountError: false,
        lengthError: false,
        lastNameError: false,
        passwordAgainError: false,
        emailMissing: false,
      },
      isEmailValidationRequested: false,
      isEmailValidated: false,
      isPhoneValidationRequested: false,
      isPhoneValidated: false,
      isPasswordSet: false,
      isAuthenticated: false,
      canStep1forward: true,
      canStep2forward: false,
      canStep3forward: false,
      terms: false,
      creditCheck: false,
      defaultCheck: false,
      completeEventSent: false,
      attachments: [],
      isUploading: false,
      isSavingAfterStep1: false,
      formInteractionStarted: false // Track if user has started interacting with form
    };

    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleAmountChangeSlider = this.handleAmountChangeSlider.bind(this);
    this.handleLengthChangeSlider = this.handleLengthChangeSlider.bind(this);

    this.handleLengthChange = this.handleLengthChange.bind(this);
    this.validateEmailClick = this.validateEmailClick.bind(this);
    this.requestNewEmailVerificationClick = this.requestNewEmailVerificationClick.bind(this);
    this.handleEmailVerificationChange = this.handleEmailVerificationChange.bind(this);
    this.validatePhoneClick = this.validatePhoneClick.bind(this);
    this.requestNewPhoneVerificationClick = this.requestNewPhoneVerificationClick.bind(this);
    this.handlePhoneVerificationChange = this.handlePhoneVerificationChange.bind(this);
    this.handleLoanPurposeTypeEnumChange = this.handleLoanPurposeTypeEnumChange.bind(this);
    this.handleLoanDueDateTypeEnumChange = this.handleLoanDueDateTypeEnumChange.bind(this);
    this.authenticate = this.authenticate.bind(this);
    this.validatePasswordAgain = this.validatePasswordAgain.bind(this);
    this.incLength = this.incLength.bind(this);
    this.decLength = this.decLength.bind(this);
    this.incAmt = this.incAmt.bind(this);
    this.decAmt = this.decAmt.bind(this);
    this.validateFirstView = this.validateFirstView.bind(this);
    this.handleAttachmentsChange = this.handleAttachmentsChange.bind(this);
    this.handleFormInteractionStart = this.handleFormInteractionStart.bind(this);

  }

  // Handle form interaction start and trigger GTM event
  handleFormInteractionStart = () => {
    if (!this.state.formInteractionStarted) {
      this.setState({ formInteractionStarted: true });
      
      // Send GTM event for credit limit application form interaction started
      trackEvent('kr_process_started', {
        "process_name": "credit_limit"
      });
      
    }
  }

  incLength = () => {
    let val = parseInt(this.state.application.loanLength);
    val = val + lenStep;
    if (val > maxLen)
      val = maxLen;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanLength: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, val, 0, this.state.application.capitalFreeMonths); }
    );

  }
  decLength = () => {
    let val = this.state.application.loanLength;
    val = val - lenStep;
    if (val < minLen)
      val = minLen;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanLength: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, val, 0, this.state.application.capitalFreeMonths); }
    );
  }

  incFree = () => {
    let val = this.state.application.capitalFreeMonths;
    val = val + lenStep;
    if (val > maxFree)
      val = maxFree;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        capitalFreeMonths: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths); }
    );

  }
  decFree = () => {
    let val = this.state.application.capitalFreeMonths;
    val = val - lenStep;
    if (val < minFree)
      val = minFree;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        capitalFreeMonths: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths); }
    );
  }




  handleAttachmentsChange = (attachments) => {
    this.setState({
      ...this.state,
      attachments: attachments
    });
  }

  validateFirstView = () => {
    // valid fields

    let email = this.state.application.email !== undefined && this.isEmailOk(this.state.application.email);
    let name = this.state.application.companyName !== undefined && this.state.application.companyName.length > 0
    let phone = this.state.application.phone !== undefined && this.isPhoneOk(this.state.application.phone);
    let bic = this.state.application.bic !== undefined && this.state.application.bic.length > 0;
    let check = this.state.defaultCheck;

    this.setState({
      ...this.state,
      validation:
      {
        ...this.state.validation,
        emailError: !email,
        companyNameError: !name,
        phoneError: !phone,
        BICError: !bic,
      }
    }, () => {
      if (this.state.defaultCheck !== true)
        this.setState({
          ...this.state,
          defaultRequired: true
        }, () => {

        })
    });
    if (email && name && phone && bic && check)
      this.handleNext();

  }

  incAmt = () => {
    let val = parseInt(this.state.application.loanAmount);
    val = val + amtStep;
    if (val > maxAmt)
      val = maxAmt;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanAmount: val
      }
    }, () => { this.props.getOffer(val, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths); }
    );
  }

  decAmt = () => {
    let val = this.state.application.loanAmount;
    val = val - amtStep;
    if (val < minAmt)
      val = minAmt;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanAmount: val
      }
    }, () => { this.props.getOffer(val, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths); }
    );
  }

  authenticate = async () => {
    console.log("authenticate called, saving application with attachments first");
    console.log("current attachments state:", this.state.attachments);
    
    // Clear previous upload logs
    localStorage.removeItem('uploadLogs');
    
    // Show loading state
    this.setState({ ...this.state, isUploading: true });
    
    // Save the application with attachments before authentication
    let appl = { ...this.state.application }
    const applicationWithAttachments = { 
      ...appl, 
      monthlyPayment: this.props.offer.offerdata.loanDetails.monthlyPmt, 
      attachments: this.state.attachments 
    };
    
    console.log("saving application before authentication:", applicationWithAttachments);
    
    try {
      // Save application and wait for it to complete (including file uploads)
      await this.props.saveApplication(applicationWithAttachments);
      console.log("application and attachments saved successfully, proceeding with authentication");
      
      // Send GTM event for credit limit application process completed (before authentication)
      trackEvent('kr_process_completed', {
        "process_name": "credit_limit"
      });
      
      // Hide loading state
      this.setState({ ...this.state, isUploading: false });
      
      // Add a small delay to ensure all uploads are complete
      setTimeout(() => {
        // Use createLoginToken which will handle getting the token and redirecting to NETS
        // serviceId 11 is for limit loan applications
        this.props.createLoginToken(11, 1, this.props.application.id);
      }, 500);
      
    } catch (error) {
      console.error("Error saving application:", error);
      
      // Send GTM error event
      trackEvent('kr_process_error', {
        "process_name": "credit_limit",
        "error_message": error.message || "Error saving application before authentication"
      });
      
      // Hide loading state
      this.setState({ ...this.state, isUploading: false });
      // Still proceed with authentication even if save fails
      setTimeout(() => {
        this.props.createLoginToken(11, 1, this.props.application.id);
      }, 500);
    }
  }

  validatePasswordAgain = () => {
    if (this.state.application.password !== this.state.application.passwordAgain) {
      this.setState({
        ...this.state,
        validation:
          { ...this.state.validation, passwordAgainError: true }
      })
    } else {
      this.setState({
        ...this.state,
        validation:
          { ...this.state.validation, passwordAgainError: false }
      })
    }
  }


  validateEmailClick = () => {
    this.setState({ ...this.state, isEmailValidationRequested: true });
    this.props.valEmail(this.state.application);
    //dispatch send code
    //add notification class to div      
  }

  requestNewEmailVerificationClick = () => {
    //dispatch resend code
  }

  handleEmailVerificationChange = (event) => {
    let val = event.target.value;
    //dispatch check code
  }

  handleTermsClick = (event) => {
    this.setState({ ...this.state, terms: event.target.checked })
  }


  handleDefaultCheckClick = (event) => {
    let checked = event.target.checked;
    this.setState({ ...this.state, defaultCheck: checked }, () => {
      if (checked && this.state.defaultRequired)
        this.setState({ ...this.state, defaultRequired: false })
    })
  }

  handleApplicationTypeCheckClick = (event) => {
    let checked = event.target.checked;
    let val = 0;
    if (checked === true)
      val = 1;
    this.setState({
      application: {
        ...this.state.application,
        loanApplicationTypeEnum: val
      }
    }
    );
  }

  handlefreeMonthsToPaymentsCheckClick = (event) => {
    let checked = event.target.checked;
    let val = 0;
    if (checked === true)
      val = 1;

    if (val === 0) {
      this.setState({
        application: {
          ...this.state.application,
          freeMonthsToPaymentsCheck: val, capitalFreeMonths: 0
        }
      }, () => { this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths) }
      );
    }

    if (val === 1) {
      this.setState({
        application: {
          ...this.state.application,
          freeMonthsToPaymentsCheck: val, capitalFreeMonths: 1
        }
      }, () => { this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths) }
      );
    }

  }


  validatePhoneClick = () => {
    this.setState({ ...this.state, isPhoneValidationRequested: true });
    this.props.valPhone(this.state.application);

    //add notification class to div
    //dispatch send code
  }

  requestNewPhoneVerificationClick = () => {
    //dispatch resend code
  }

  handlePhoneVerificationChange = (event) => {
    let val = event.target.value;
    //dispatch check code
  }

  componentWillReceiveProps = (nextProps) => {

    if (nextProps.application.zip !== this.props.zip ||
      nextProps.application.contactDetails !== this.props.contactDetails ||
      nextProps.application.address !== this.props.address ||
      nextProps.application.id !== this.props.id) {
      this.setState({
        application:
        {
          ...this.state.application,
          ...nextProps.application
        }
      }, () => {/* // console.log(this.state) */ }
      )
    }

    if (nextProps.authentication
      && nextProps.authentication.isAuthenticated
      && nextProps.authentication.isAuthenticated === true) {
      this.setState({ ...this.state, activeStep: 4 },)
    }
  }


  handleAmountChange = (event) => {
    let val = 0;
    let selVal = 0;
    /*
    if (event.target.value === "" || event.target.value === undefined) 
      val = 2000
    else 
    */
    val = parseInt(event.target.value);

    if (val <= maxAmt && val >= minAmt)
      selVal = val;


    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanAmount: val
      }
    }, () => {
      this.props.getOffer(selVal, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths);
    }
    );
  };


  handleLengthChange = (event) => {

    let val = 0;
    let selVal = 0;
    val = parseInt(event.target.value);

    if (val <= maxLen && val >= minLen)
      selVal = val;

    /* if (event.target.value === "" || event.target.value === undefined) 
      val = 1
    else 
      val = parseInt(event.target.value);
      
    if (val > 24)
      val = 24;
    if (val < 1)
      val = 1;
      */
    this.setState({
      application: {
        ...this.state.application,
        loanLength: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, selVal, 0, this.state.application.capitalFreeMonths) });

  };


  handleFreeMonthsChange = (event, value) => {

    let val = parseInt(value);
    let selVal = 0;

    if (val <= maxFree && val >= minFree)
      selVal = val;

    if (val < minFree)
      val = minFree;

    if (val > maxFree)
      val = maxFree;


    /* if (event.target.value === "" || event.target.value === undefined) 
      val = 1
    else 
      val = parseInt(event.target.value);
      
    if (val > 24)
      val = 24;
    if (val < 1)
      val = 1;
      */
    this.setState({
      application: {
        ...this.state.application,
        capitalFreeMonths: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths) });

  };


  handleAmountChangeSlider = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let val = parseInt(value);
    this.setState({
      application: {
        ...this.state.application,
        loanAmount: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths) });
  };



  handleLengthChangeSlider = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let val = parseInt(value);
    this.setState({
      application: {
        ...this.state.application,
        loanLength: val
      }
    }, () => { this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths) });
  };





  handleCbChange = name => (event, checked) => {
    this.setState({
      application: {
        ...this.state.application,
        [name]: checked
      }
    });
  };
  // validations



  isEmailOk = (val) => {
    this.setState({ validation: { ...this.state.validation, emailFormatError: false } });
    if (val === undefined || val === "") {
      return false;
    }
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailOk = re.test(val);

    return emailOk;
  }

  isPhoneOk = (val) => {
    return true;
  }

  validateEmail = () => {
    if (this.isEmailOk(this.state.application.email)) {
      this.setState({ validation: { ...this.state.validation, emailError: false } });
      return true;
    }
    else {
      this.setState({ validation: { ...this.state.validation, emailError: true } });
      return false;
    }
  }

  validatePhone = () => {
    if (this.isPhoneOk(this.state.application.phone)) {
      this.setState({ validation: { ...this.state.validation, phoneError: false } });
      return true;
    }
    else {
      this.setState({ validation: { ...this.state.validation, phoneError: true } });
      return false;
    }
  }
  isNumberOk = (val) => {
    return true;
  }

  handleNext = async () => {
    const { activeStep } = this.state;

    // Track with GTM
    trackButtonClick('limiitti_hakemus_nappi', 'limit_loan_form');
    trackLoanApplication('submit_limit_loan', {
      loan_amount: this.state.application.loanAmount,
      loan_length: this.state.application.loanLength,
      step: activeStep,
      loan_type: 'limit_loan',
      loan_type_enum: 2
    });

    this.props.updateApplication(this.state.application);
    
    // Save application after step 1 (basic information step)
    if (activeStep === 0) {
      this.setState({ isSavingAfterStep1: true });
      try {
        console.log("Saving limit loan application after step 1 (basic info):", this.state.application);
        let appl = { ...this.state.application }
        await this.props.saveApplication({ ...appl, monthlyPayment: this.props.offer.offerdata.loanDetails.monthlyPmt });
        console.log("Limit loan application saved successfully after step 1");
      } catch (error) {
        console.error("Error saving limit loan application after step 1:", error);
        
        // Send GTM error event
        trackEvent('kr_process_error', {
          "process_name": "credit_limit",
          "error_message": error.message || "Error saving application after step 1"
        });
        
        // Continue to next step even if save fails
      } finally {
        this.setState({ isSavingAfterStep1: false });
      }
    }

    // Note: kr_process_completed is now tracked in authenticate() function
    // when the user completes the final step and authentication is initiated

    this.setState({ activeStep: activeStep + 1 });
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  handleBicChange = name => event => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        [name]: event.target.value
      }
    }, () => { this.validateEmail() });
  };


  handleChange = (name, appl) => event => {
    // step0
    if (name === "email") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validateEmail() });
    }
    else if (name === "discountCode") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => {});
    }
    else if (name === "phone") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validatePhone() });
    }
    else if (name === "bic") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      },
        () => {

          if (this.state.application.bic.length > 8) {
            this.props.getYtjInformation(this.state.application.bic);
            this.setState({
              ...this.state,
              validation:
              {
                ...this.state.validation,
                BICError: false
              }
            });

          }

        });

    }

    else if (name === "passwordAgain") {

      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validatePasswordAgain() });
    }

    else if (name === "emailCode") {
      let val = event.target.value;
      this.setState({ ...this.state, emailCode: val },
        () => {

          if (val.length >= 4) {
            this.setState({
              ...this.state,
              application: {
                ...this.state.application,
                [name]: val
              }
            }, () => {
              this.props.tryValEmailCode(this.state.application);
            });
          }

        });


    }

    else if (name === "phoneCode") {
      let val = event.target.value;

      this.setState({ ...this.state, phoneCode: val },
        () => {

          if (val.length >= 4) {
            this.setState({
              ...this.state,
              application: {
                ...this.state.application,
                [name]: val
              }
            }, () => {
              this.props.tryValPhoneCode(this.state.application);
            });
          }

        });

    }
    else this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        [name]: event.target.value
      }
    });
  }

  getStore() {
    return this.props.applicant;
  }
  isStepOptional = step => {
    // return step === 1;
    return false;
  };
  handleLoanPurposeTypeEnumChange = (event) => {
    // this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, event.target.value, this.state.coApplicant);             
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanPurposeTypeEnum: event.target.value
      }
    });
  }

  handleLoanDueDateTypeEnumChange = (event) => {
    this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, event.target.value, 0, this.state.application.capitalFreeMonths);
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanDueDateTypeEnum: event.target.value
      }
    });

  }

  handleLoanGuaranteeTypeEnumChange = (event) => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanGuaranteeTypeEnum: event.target.value
      }
    });
  }

  componentDidMount = () => {

    const values = queryString.parse(this.props.authUserId.params.id);
    const query = queryString.parse(this.props.search);
    let affiliateSrc = "";

    const affiliateCookie = getCookie('affiliation'); 

    let gclid =  '';
    if(affiliateCookie)
    {
        const affiliateData = JSON.parse(decodeURIComponent(affiliateCookie));
        gclid = getGclidFromQuery(affiliateData.query);
    }

    let consolidation = 0;
    if (query.replace === '1' || values.replace === '1' || query.consolidation === 'true') {
      consolidation = 1;
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          loanApplicationTypeEnum: consolidation,
        },
      });
    }

    if (values.sr !== undefined || query.sr !== undefined) {
      affiliateSrc = "Google Ads";
    }

    let affiliateCode = '';
    if(gclid)
    {
      affiliateCode = gclid;
      affiliateSrc = 'Google';
    }

    if (values.loanamount !== undefined) {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          loanAmount: values.loanamount,
          affiliateCode: affiliateCode ? affiliateCode : values.sr,
          affiliate: affiliateSrc,
          loanApplicationTypeEnum: consolidation,
        }
      }, () => {
        this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths);
      }
      );
      return;
    }

    let affMedium = "";
    let affCampaign = "";
    let affCv = "";
    let affAt_gd = "";

    if (query !== undefined && !gclid) {

      if (query.utm_source !== undefined)
        affiliateSrc = query.utm_source;

      if (query.sr !== undefined)
        affiliateSrc = query.sr;

      if (query.utm_medium !== undefined)
        affMedium = query.utm_medium;

      if (query.utm_campaign !== undefined)
        affCampaign = query.utm_campaign;

      if (query.at_gd !== undefined)
        affAt_gd = query.at_gd;

      if (query.sr !== undefined)
        affAt_gd = query.sr;

      if (query.coid !== undefined) {
        affAt_gd = query.coid;
        if (query.utm_medium !== undefined)
          affiliateSrc = query.utm_medium;
      }


      if (affAt_gd !== "")
        this.setState({
          ...this.state,
          application: {
            ...this.state.application,
            affiliate: affiliateSrc,
            affiliateCode: affAt_gd
          }
        })

    }

    if(gclid){
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          affiliate: affiliateSrc,
          affiliateCode: affiliateCode,
        }
      })
    }

    this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths)

  }



  render() {
    const steps = getSteps();
    const { activeStep } = this.state;
    const { classes } = this.props;

    return (
      <Box style={{ color: "white" }}>

        <Hidden smDown>
          <div style={{ marginTop: "20px" }} />
        </Hidden>
        {this.props.application.isEmailValidated === true &&
          <Snack message={"Sähköpostiosoite " + this.state.application.email + " vahvistettu"} />
        }
        {this.state.isPhoneValidated === true &&
          <Snack message={"Matkapuhelinnumero " + this.state.application.phone + " vahvistettu"} />
        }

        <Grid container spacing={4}>

          {activeStep === 0 &&

            <Grid item xs={12}>

              {/* loan params */}
              <Grid container spacing={4}>
                <Grid item md={8}>

                  <Paper elevation={3} style={{ padding: "32px", height: '100%' }}>

                    <Hidden smDown>
                      <Typography variant='h3'>Kasvurahoitus luottolimiitti</Typography>

                      <ul className={classes.checkmarkList}>
                        <li><Typography variant='body1'>Avausmaksu 0€</Typography></li>
                        <li><Typography variant='body1'>Limiittinostoja voi tehdä limiitin puitteissa vapaasti</Typography></li>
                        <li><Typography variant='body1'>Pääoman takaisinmaksut vapauttavat limiittiä uudelleen käytettäväksi</Typography></li>
                      </ul>
                    </Hidden>

                    <Grid container direction='row' spacing={3} style={{ backgroundColor: '#fff', border: `1px solid ${COLOR_CENTER_BORDER}`, padding: '30px', textAlign: 'left' }}>
                      <Grid item xs={12}>
                        <Grid container spacing={6}>
                          <Grid item xs={12} style={{ paddingBottom: 0 }}>
                            <Grid container>
                              <Grid item xs={12}>
                                <Grid container>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorSliderText}>Haettavan limiittiluoton määrä</Typography>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right' }}>
                                      {this.state.application.loanAmount.toLocaleString('fi')} €
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <Slider
                                  value={this.state.application.loanAmount}
                                  onChange={this.handleAmountChangeSlider}
                                  min={2000}
                                  max={50000}
                                  step={1000}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
{/*
                          <Grid item xs={12} md={6} style={{ paddingBottom: 0 }}>
                            <Grid container>
                              <Grid item xs={12}>
                                <Grid container>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorSliderText}>Laina-aika</Typography>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right' }}>
                                      {this.state.application.loanLength} kk
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <Slider
                                  value={this.state.application.loanLength}
                                  onChange={this.handleLengthChangeSlider}
                                  min={2}
                                  max={24}
                                  step={1}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Grid container>
                              <Grid item xs={12}>
                                <Grid container>
                                  <Grid item xs={9}>
                                    <Typography className={classes.calculatorSliderText}>Lyhennysvapaita kuukausia 0-3 kk</Typography>
                                  </Grid>
                                  <Grid item xs={3}>
                                    <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right' }}>
                                      {this.state.application.capitalFreeMonths.toLocaleString('fi')} kk
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <Slider
                                  value={this.state.application.capitalFreeMonths}
                                  onChange={this.handleFreeMonthsChange}
                                  min={0}
                                  max={3}
                                  step={1}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
*/}

                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={this.state.application.capitalFreeMonths > 0}>
                          <Grid container spacing={0}>
                            <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox} style={{ borderBottom: '0 none' }}>
                              <Typography className={classes.calculatorMonthlyPaymentDetailText}>Laina-aika</Typography>
                              <Typography className={classes.calculatorNumber}>
                                {this.props.offer.offerdata.loanParameters ? this.props.offer.offerdata.loanParameters.loanLength : 0} kk
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox} style={{ borderBottom: '0 none', textAlign: 'center' }}>
                              <Typography className={classes.calculatorMonthlyPaymentDetailText}>
                                Kuukausierä, kun limiittiä on käytössä täysimääräisesti *)
                                
                                
                                {/* ({this.state.application.capitalFreeMonths === 1 ? '1. kuukausi' : `kuukaudet 1-${this.state.application.capitalFreeMonths}` })
                                */}
                              </Typography>
                              <Typography className={classes.calculatorNumber} style={{textAlign: 'center'}}>
                                {/*
                                {(Math.round(((this.props.offer.offerdata.interests ? this.props.offer.offerdata.interests[0] : 0) + Number.EPSILON) * 10) / 10).toLocaleString('fi')} € / kk
                                */}
                                {(Math.round(this.state.application.loanAmount / 0.02)).toLocaleString('fi')} €
                              </Typography>
                            </Grid>
                          </Grid>
                        </Collapse>
                        <Grid container spacing={0}>
                          <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox}>
                            <Typography className={classes.calculatorMonthlyPaymentDetailText}>
                            Korkoerän suuruus kuukaudessa, kun limiitti on käytössä täysimääräisesti
                              {this.state.application.capitalFreeMonths > 0 ? ` (kuukaudet ${this.state.application.capitalFreeMonths + 1}-${this.props.offer.offerdata.loanParameters ? this.props.offer.offerdata.loanParameters.loanLength : 0}) ` : ' '}
                              *
                            </Typography>
                            <Typography className={classes.calculatorNumber}>
                              {/*
                              {(Math.round(((this.props.offer.offerdata.loanDetails ? this.props.offer.offerdata.loanDetails.monthlyPmt : 0) + Number.EPSILON) * 10) / 10).toLocaleString('fi')} € / kk
                              */}
                              {(Math.round(this.state.application.loanAmount * 0.02)).toLocaleString('fi')} €
                            </Typography>
                          </Grid>
                          {/*
                          <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox}>
                            <Typography className={classes.calculatorMonthlyPaymentDetailText}>Kokonaiskustannus</Typography>
                            <Typography className={classes.calculatorNumber}>
                              {(Math.round(((this.props.offer.offerdata.loanDetails ? this.props.offer.offerdata.loanDetails.totalPmt : 0) + Number.EPSILON) * 10) / 10).toLocaleString('fi')} €
                            </Typography>
                          </Grid>
                          */}
                          <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox}>

<Typography variant='subtitle2' style={{ margin: '12px 0 24px' }}>*) Luottolimiitissä maksat kuukaisikorkoa vain niiltä kuukausilta, kun limiittiä on käytössä.</Typography>
</Grid>
                        </Grid>
                      </Grid>
                      {/*
                      <Grid container alignItems='center' style={{ padding: '16px 16px 8px' }}>
                        <Grid item xs={10}>
                          <Typography variant='subtitle2' >
                            Haetko yhdistelylainaa nykyisten yrityslainojen korvaamiseksi Kasvurahoituksella?
                          </Typography>
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'center' }}>
                          <Box>
                            <Switch color="primary" checked={this.state.application.loanApplicationTypeEnum === 1} onChange={this.handleApplicationTypeCheckClick} name="checkedC" />
                          </Box>
                          <Typography variant='subtitle2' style={{ marginTop: '-6px' }}>
                            {this.state.application.loanApplicationTypeEnum === 1 ? 'Kyllä' : 'Ei'}
                          </Typography>
                        </Grid>
                      </Grid>

                      */}
                      
                      <Hidden xsDown >
                      <Grid item xs={12}>

                      <div class="trustpilot-widget" data-locale="fi-FI" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="607582d37881d800016abf4e" data-style-height="140px" data-style-width="100%" data-theme="light" data-stars="1,2,3,4,5" data-review-languages="fi">
  <a href="https://fi.trustpilot.com/review/kasvurahoitus.fi" target="_blank" rel="noopener">Trustpilot</a>
</div>


                        </Grid>
                        </Hidden>

                    </Grid>
                    
                  </Paper>



                </Grid>
         

                <Grid item md={4}>
                  <Paper elevation={3} style={{ padding: "32px", height: '100%', textAlign: 'left' }}>
                    <Typography variant='h3'>Luottolimiitin avaus</Typography>
                    <Typography variant='subtitle2' style={{ margin: '12px 0 24px' }}>Täytä yrityksen perustiedot huolellisesti limiitin avaamista varten. Voit muuttaa limiittiluoton määrää vielä myöhemmin.</Typography>

                    <TextField
                      autoFocus
                      error={this.state.validation.BICError}
                      helperText={this.state.validation.BICError ? 'Y-tunnus puuttuu tai on virheellinen.' : ''}
                      placeholder="Rahoitusta hakevan yrityksen Y-tunnus"
                      variant="outlined"
                      fullWidth
                      value={this.state.application.bic}
                      onChange={this.handleChange('bic')}
                    />

                    <Collapse in={this.props.application.isPrhFetched}>
                      <Typography variant='subtitle2' style={{ fontWeight: '12px', margin: '4px 0' }}>Yrityksen tiedot saatiin noudettua Patentti- ja rekisterihallitukselta. </Typography>
                    </Collapse>

                    <TextField
                      id="companyName"
                      fullWidth
                      error={this.state.validation.companyNameError}
                      placeholder="Yrityksen nimi"
                      variant="outlined"
                      value={this.state.application.companyName}
                      onChange={this.handleChange('companyName')}
                    />

                    <TextField
                      error={this.state.validation.emailError}
                      placeholder="Yhteyshenkilön sähköpostiosoite"
                      variant="outlined"
                      fullWidth
                      value={this.state.application.email}
                      onChange={this.handleChange('email')}
                    />

                    <TextField
                      fullWidth
                      error={this.state.validation.phoneError}
                      placeholder="Yhteyshenkilön puhelin"
                      variant="outlined"
                      value={this.state.application.phone}
                      onChange={this.handleChange('phone')}
                    />

                    <TextField
                      fullWidth                      
                      placeholder="Kampanjakoodi"
                      variant="outlined"
                      value={this.state.application.discountCode}
                      onChange={this.handleChange('discountCode')}
                    />


                    <Box style={{ marginTop: "16px", background: '#fff', border: '1px solid #EBEBEA', textAlign: "left" }}>


                      <Grid container alignItems='center' style={{ padding: '8px 16px 16px' }}>
                        <Grid item xs={10}>
                          <Typography variant='subtitle2' style={{ fontSize: "12px" }}>
                            Hyväksyn Kasvurahoituksen <a target="_blank" title="Kasvurahoitus yrityslaina käyttöehdot" href="https://www.kasvurahoitus.fi/front-kasvurahoitus-kaeyttoeehdot/">käyttöehdot</a>.
                          Annan suostumuksen tietojen noutamiseen ja käsittelyyn luottotietorekisteristä sekä muista saatavilla olevista tietolähteistä.
                          </Typography>
                          {this.state.defaultRequired === true && <Typography variant='subtitle2' style={{ color: "red" }}><br />Sinun tulee hyväksyä käyttöehtomme jatkaaksesi</Typography>}
                        </Grid>

                        <Grid item xs={2} style={{ textAlign: 'center' }}>
                          <Box>
                            <Switch color="primary" checked={this.state.defaultCheck} onChange={this.handleDefaultCheckClick} name="checkedC" />
                          </Box>
                          <Typography variant='subtitle2' style={{ marginTop: '-6px' }}>
                            {this.state.defaultCheck ? 'Kyllä' : 'Ei'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    <div style={{width: "100%", textAlign: "center"}}>


                    <Button
                      style={{ marginTop: '24px' }}
                      color="primary"
                      variant="contained"
                      endIcon={this.state.isSavingAfterStep1 ? null : <React.Fragment>→</React.Fragment>}
                      size='large'
                      onClick={() => { this.validateFirstView() }}
                      disabled={this.state.isSavingAfterStep1}
                    >
                      {this.state.isSavingAfterStep1 
                        ? 'Tallennetaan...'
                        : (activeStep === steps.length - 1 ? 'Finish' : 'Pyydä lainatarjous')
                      }
                    </Button>

                   
                      </div>

                  </Paper>
                </Grid>

              </Grid>
            </Grid>
          }

          {activeStep === 99 && <Grid item xs={12}><Paper elevation={3} style={{padding: '32px'}}>

            <div className="marginTop20" style={{ textAlign: "left" }}>
              <div className="applyForm">
                <div className="container">
                  <h1 style={{ textAlign: "center" }}>Salasana yritysportaaliin</h1>

                  <div className="applyLoanInfo2 applyForm applicationConditions">

                    <div className="row">

                      <div className="col-md-6 applyInputInfo">
                        <p>
                          Aseta salasana, jota käytät kirjautuessasi palveluun tunnuksella {this.state.application.email}</p>
                      </div>
                      <div className="col-md-1">
                        <img src="/img/icon_key.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>

                      <div className="col-md-5"> {/* content for pwd validation */}
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="marginTop20" />

                            <TextField
                              error={this.state.validation.passwordError}
                              label="Salasana"
                              fullWidth={true}
                              type="password"
                              value={this.state.application.password}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('password')} />

                            {this.state.validation.phoneError === true &&
                              <div>
                                <p>Salasanan muoto on virheellinen.</p>
                              </div>}
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="marginTop20" />
                            <TextField
                              error={this.state.validation.passwordAgainError}
                              label="Salasana uudestaan"
                              fullWidth={true}
                              type="password"
                              value={this.state.application.passwordAgain}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('passwordAgain')} />

                            {this.state.validation.passwordAgainError === true &&
                              <div>
                                <p>Salasanojen tulee täsmätä</p>
                              </div>}
                          </div>
                        </div>
                        {/* eof content for pwd validation */}
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div className="applyForm" style={{ textAlign: "left" }}>
              <div className="container">
                <h1 style={{ textAlign: "center" }}>Hakijan tiedot</h1>
                <div className="row">
                  <div className="col-md-2">
                    <img src="/img/icon_travelbook.png" style={{ width: "100px" }} />
                  </div>
                  <div className="col-md-10">

                    <div className="marginTop20"> <h1>Käyttäjätunnuksen valinta</h1> </div>
                    <div className="row">
                      <div className="col-md-6 applyInputInfo"> <p>
                        {/* <IconLock style={iconStyle}/> */} Sähköpostiosoitteesi toimii samalla käyttäjätunnuksena palveluun </p> </div>
                      <div className="col-md-1">
                        <img src="/img/icon_envelope.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>

                      <div className="col-md-5">

                        {this.props.application.isEmailValidationRequested === true && this.props.application.isEmailValidated === false &&
                          <div className="row">
                            <div className="col-12 col-md-12 applyLoanHighlight" style={{ marginTop: "20px" }}>
                              <Snack message={"Vahvistuskoodi lähetetty sähköpostiin " + this.state.application.email} />
                              <p>Lähetimme vahvistuskoodin sähköpostiisi. Ole hyvä ja syötä koodi allaolevaan kenttään. </p>
                              <div className="row">
                                <div className="col-11 col-md-11">
                                  <TextField id="emailCode"
                                    fullWidth={true}
                                    label="Tunniste"
                                    InputLabelProps={{}}
                                    value={this.state.emailCode}
                                    onChange={this.handleChange('emailCode')}
                                  />
                                </div>
                                <div className="col-1 col-md-1">
                                  {this.state.validation.BICError === false && <div> <IconOk style={okStyle} /> </div>}
                                  {this.state.validation.BICError === true && <div> <IconError style={errorStyle} /> </div>}
                                </div>
                              </div>

                              <p style={{ marginTop: "20px" }}>Etkö saanut vahvistusviestiä sähköpostiisi? Huomaathan, että viestin saapumiseen voi mennä jopa useita minuutteja. </p>
                              <Button>Lähetä uusi vahvistuskoodi</Button>
                            </div>
                          </div>
                        }

                        {this.props.application.isEmailValidationCodeRequested === true && <div style={{ textAlign: "center" }}> <CircularProgress /> </div>}
                        {this.props.application.isEmailValidationRequested === true && this.props.application.isEmailValidated === true && <div> Sähköpostiosoite <i>{this.state.application.email}</i> on vahvistettu onnistuneesti  <IconOk style={okStyle} /> </div>}

                      </div>
                    </div>
                    {/*
    {(this.props.application.isEmailValidated === true || this.props.application.isEmailValidated === false) && 
    <div className="applyLoanHighlight">
    */}

                    <div className="marginTop20">
                      <h1>Matkapuhelinnumero</h1>
                    </div>

                    <div className="row">
                      <div className="col-md-6 applyInputInfo">
                        <p>
                          Numerosta saamme tarvittaessa yhteyden hakemukseen liittyvissä asioissa </p>
                      </div>
                      <div className="col-md-1">
                        <img src="/img/icon_phone2.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>
                      <div className="col-md-5">
                        {/* content for mobile validation */}

                        <div className="row">
                          <div className="col-11 col-md-11">
                            <div className="marginTop20" />

                            <TextField
                              error={this.state.validation.phoneError}
                              label="Matkapuhelinnumero"
                              fullWidth={true}
                              value={this.state.application.phone}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('phone')} />
                            {/* this.state.validation.phoneError === true && <div> <p>Matkapuhelimen numeron muoto on virheellinen.</p> </div> */}
                          </div>
                          <div className="col-1 col-md-1">
                            {this.state.validation.phoneError === false && <div> <IconOk style={okStyle} /> </div>}
                            {this.state.validation.phoneError === true && <div> <IconError style={errorStyle} /> </div>}
                          </div>
                        </div>
                        {this.props.application.isPhoneValidationCodeRequested === true && <div style={{ textAlign: "center" }}> <CircularProgress /> </div>}
                        {this.props.application.isPhoneValidated === true && <div> <p>Olet vahvistanut numeron <i>{this.state.application.phone}</i> onnistuneesti <IconOk style={okStyle} /></p> </div>}

    {/* do not use Mobile validation for conversion reasons
        {this.state.validation.phoneError === false && this.props.application.isPhoneValidated === false &&
          <div className="row">
            <div className="col-12 col-md-12" style={{marginTop: "10px"}}>    
            <p>Lähetämme matkapuhelimeen vahvistustunnuksen, jolla vahvistat liittymän hallinnan.</p>   
              <Button raised color="primary"  onClick={() => {this.validatePhoneClick()}}>Lähetä vahvistusviesti</Button>  
            </div>
          </div>
        }
      */}

                        {this.props.application.isPhoneValidationRequested === true && this.props.application.isPhoneValidated === false &&
                          <div className="row">
                            <div className="col-12 col-md-12 applyLoanHighlight" style={{ marginTop: "20px" }}>
                              <Snack message={"Vahvistuskoodi lähetetty matkapuhelimeen " + this.state.application.phone} />
                              <p>Lähetimme vahvistuskoodin puhelimeesi. Ole hyvä ja syötä koodi allaolevaan kenttään. </p>
                              <div className="row">
                                <div className="col-11 col-md-11">
                                  <TextField id="phoneCode"

                                    fullWidth={true}
                                    label="Tunniste"
                                    InputLabelProps={{

                                    }}
                                    value={this.state.phoneCode}
                                    onChange={this.handleChange('phoneCode')}
                                  />
                                </div>
                              </div>
                              {/* <p style={{marginTop: "20px"}}>Etkö saanut vahvistusviestiä matkapuhelimeesi? Huomaathan, että viestin saapumiseen voi mennä jopa useita minuutteja. </p><Button>Lähetä uusi</Button> */}

                            </div>
                          </div>
                        }
                        {/* eof content for mobile validation */}
                      </div>
                    </div>
                    {/*password set*/}
                    <div className="marginTop20">
                      <h1>Salasana palveluun</h1>
                    </div>


                    {/*end of password set */}
                  </div>
                </div>
              </div>
            </div>
            </Paper>
          </Grid>
          }

          {activeStep === 1 &&

            <Grid item xs={12}>
              <Paper elevation={3} style={{ padding: "32px", textAlign: 'left' }}>
                <Typography variant='h3' style={{ marginBottom: '16px' }}>Vaihe 2 / 2</Typography>

                <Typography variant='body2'>
                  Pyydämme vielä tunnistautumaan pankkitunnuksilla tai mobiilivarmenteella.
                  <br />                  
                  <br />
                  Tarjouksen pyytäminen on maksutonta eikä sido yritystäsi vielä mihinkään.
                </Typography>

                {this.state.isSavingAfterStep1 && (
                  <Box style={{ textAlign: 'center', margin: '20px 0' }}>
                    <CircularProgress />
                    <Typography variant='body2' style={{ marginTop: '10px' }}>
                      Tallennetaan hakemustasi...
                    </Typography>
                  </Box>
                )}

                <OptionalAttachments 
                  onAttachmentsChange={this.handleAttachmentsChange} 
                  loanType={2}
                />
                {this.props.application.isFetching === true &&
                  <Box style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </Box>
                }
                {this.props.application.isFetching === false && <Box style={{ textAlign: 'center', display:'flex', paddingTop:'20px' }}>

                  <Button
                    className="applyContinueBtn"
                    color="primary"
                    variant="contained"
                    size='large'
                    onClick={this.authenticate}
                    disabled={this.state.isUploading}
                  >
                    {this.state.isUploading 
                      ? (this.state.attachments.length > 0 
                          ? `Lähetetään ${this.state.attachments.length} tiedosto(a)...`
                          : 'Tallennetaan hakemusta...'
                        )
                      : 'Viimeistele hakemus tunnistautumalla'
                    }
                    </Button>

                </Box>}
                {this.props.authentication.isAuthenticated === true && <Box style={{ textAlign: 'center' }}>
                  Hetu: {this.props.authentication.ssn}
                </Box>}
              </Paper>
            </Grid>

          }
          {activeStep === 4 &&

            <Grid item xs={12}>
              <Paper elevation={3} className="applyForm" style={{ padding: "32px", textAlign: "left" }}>

                {this.props.application.isFetching === false &&
                  <Snack message={"Tunnistautuminen onnistui " + this.props.application.firstName + " " + this.props.application.lastName + " (" + this.props.application.ssn + ")"} />
                }
                {this.props.application.isFetching === true &&
                  <Box style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </Box>}
                {this.props.application.isFetching === false && <Box>
                  <Typography variant='h3' style={{ marginBottom: '16px' }}>Lainahakemuksesi on rekisteröity ja otettu käsittelyyn</Typography>

                  <Typography variant='body2'>Olemme yhteydessä yhden arkipäivän kuluessa mahdollisissa hakemuksen käsittelyyn liityvissä kysymyksissä. </Typography>
                  {/*
                  {this.state.activeStep === 4 &&
                    <ApplicationDetails />
                  }
                  */}
                </Box>}


              </Paper>
            </Grid>

          }

          {/* Begin of Back / Forward buttons */}
          {(activeStep === steps.length || activeStep === 0) ? (
            <Box></Box>
          ) : (
              <Grid item xs={12}>
                <Typography >{getStepContent(activeStep)}</Typography>
                <Box style={{ textAlign: "right" }}>

                  <Button
                    disabled={activeStep === 0}
                    onClick={this.handleBack}
                    variant='contained'
                    color='secondary'
                    size='large'
                  >
                    Edellinen
                    </Button>

                  {this.isStepOptional(activeStep) && (
                    <Button
                      variant="contained"
                      color="secondary"
                      size='large'
                      onClick={this.handleSkip}
                    >
                      Skip
                    </Button>
                  )}

                  {(
                    (this.state.activeStep === 2 && this.state.validation.emailError === false
                      && (this.props.application.isPhoneValidated === true || this.state.validation.phoneError === false)
                      && this.state.application.password !== undefined
                      && this.state.application.passwordAgain !== undefined
                      && this.state.validation.passwordAgainError === false)

                    || (this.state.activeStep === 1 && (this.state.application.isPrhFetched === true || this.state.application.bic !== "") && this.state.defaultCheck === true && this.state.terms === true)
                  ) &&
                    <Button
                      style={{ marginLeft: "10px" }}
                      color="primary"
                      variant="contained"
                      size='large'
                      onClick={() => { this.handleNext() }}
                    >
                      {activeStep === steps.length - 1 ? 'Finish' : 'Seuraava'}
                    </Button>
                  }
                </Box>
              </Grid>
            )}
          {/* End of Back / Forward buttons */}

        </Grid>

      </Box>
    )
  }

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(LimitLoanProcess);
